"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 20px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledTile = (0, _styledComponents.default)(_UITile.default).withConfig({
  displayName: "CalculatorPlanSelectorTile__StyledTile",
  componentId: "sc-1ozxqqz-0"
})(["padding:55px;min-height:600px;height:100%;width:640px;", ";", ""], _responsiveBreakpoints.default.tablet(_templateObject()), _responsiveBreakpoints.default.phone(_templateObject2()));

var CalculatorPlanSelectorTile = function CalculatorPlanSelectorTile(_ref) {
  var children = _ref.children;
  return _react.default.createElement(StyledTile, null, children);
};

var _default = CalculatorPlanSelectorTile;
exports.default = _default;
module.exports = exports.default;